// @ts-nocheck
import React, { createRef } from "react";
import BaseComponent from "../../common/BaseComponent";
import AppSetting from "../../../config/AppSetting";
import ProcedureDetailService from "../../../service/procedureFile/ProcedureDetailService";
import FileItem from "./fileItem";
import NormalModal from "../modal";
import uploadFileIcon from "../../../assets/image/uploadFileicon.png";
import tipIcon from "../../../assets/image/tipIcon.png";
import "./index.scss";
import { handleAlertUploadFileError } from "../../../app/publicDictionaryValues";

const MAX_FILE_SIZE_MB = 300;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

class UploadFile extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      refresh: false,
    };
  }

  componentDidUpdate = () => {
    if (this.state.refresh) {
      this.setState({ refresh: false });
    }
  };

  onChange = (event: any) => {
    this.props.handleFileSelect(event, this.props.rowindex, this.props.isSupportingFile);
    if (this.props.fileInputRef !== undefined) {
      this.props.fileInputRef.current.value = "";
    }
    this.setState({ refresh: true });
  };

  render() {
    const { fileInputRef, isMultiple = true, rowindex, testid } = this.props;
    return (
      !this.state.refresh && (
        <input
          ref={fileInputRef}
          type="file"
          style={{ display: "none" }}
          onChange={this.onChange}
          multiple={isMultiple}
          id={rowindex}
          data-testid={testid}
        />
      )
    );
  }
}

const fileItemRef = createRef();
class FileUploadDragger extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      fileList: [],
      fileIdList: [],
      isModalOpen: false,
      isError: false,
      modalChildContent: "",
      handleModalConfirm: () => {
        // This is an empty function
      },
      handleModalCancel: () => {
        // This is an empty function
      },
    };
    // @ts-ignore
    this.dropBox = document.getElementsByClassName("uploadInputContainer")[0];
    // @ts-ignore
    this.fileSize = 0;
    // @ts-ignore
    this.fileIndex = 0;
    // @ts-ignore
    this.fileNum = 0;
    // @ts-ignore
    this.uploadFileNum = 0;
    // @ts-ignore
    this.fileList = [];
    // @ts-ignore
    this.fileNum = 0;
    // @ts-ignore
    this.isDeleting = false;
  }

  /* function about click file Input */
  handleFileUpload = () => {
    const isEditable = this.props.isShowDeleteBtn;
    if (isEditable !== undefined && isEditable === true) {
      this.props.fileInputRef.current.click();
      this.props.fileInputRef.current.value = "";
      this.cancelMandatory();
    }
  };

  /* function about close modal */
  hideModal = () => {
    this.setState({ isModalOpen: false });
  };

  /* get param to use in the file servies api */
  getAddFileDto = (item: any) => {
    return {
      FileName: item.name,
      ContainerName: AppSetting.urlPrefix.addFile.ContainerName,
      AccountName: AppSetting.urlPrefix.addFile.AzureAccountName,
      ProductKey: AppSetting.urlPrefix.addFile.ProductKey,
      FolderName: AppSetting.urlPrefix.addFile.ProcedureFileFolder,
    };
  };

  /**
   * Remove same file from state by current file
   * @param {*} currentItem
   */
  removeSameFile = (currentItem: any) => {
    const fileIndex = this.state.fileList.findIndex((x: any) => x.name === currentItem.name);
    if (fileIndex > -1) {
      this.state.fileIdList.splice(
        this.state.fileIdList.findIndex((x: any) => x === this.state.fileList[fileIndex].fileId)
      );
      this.state.fileList.splice(fileIndex, 1);
    }
  };

  /**
   * CallBack of addFileFunc
   * @param {*} response
   * @param {*} preRequestData
   * @returns
   */
  onAddFileSuccess = (response: any, preRequestData: any) => {
    this.removeSameFile(preRequestData.dataItem);
    preRequestData.dataItem.storageFileID = response.storageFileID;
    const fileList = this.props.isMultiple
      ? [...this.state.fileList, preRequestData.dataItem]
      : [preRequestData.dataItem];
    const fileIdList = this.props.isMultiple
      ? [...this.state.fileIdList, response.storageFileID]
      : [response.storageFileID];
    this.setState({
      fileList: fileList,
      fileIdList: fileIdList,
    });
    this.props.isMultiple && this.props.handleFileListChange(fileList);

    this.props.updateFileNumLoading &&
      this.props.updateFileNumLoading({
        // @ts-ignore
        currentNum: this.fileNum - preRequestData.currentDataList.length,
        // @ts-ignore
        allNum: this.fileNum,
      });
    /// Stop callback AddFile
    if (preRequestData.currentDataList.length === 0) {
      // @ts-ignore
      this.uploadFileNum = 0;
      this.props.updateFileNumLoading != null
        ? this.props.updateFileNumLoading({
            currentNum: 0,
            allNum: 0,
          })
        : this.props.hideLoading();
      return;
    }

    // @ts-ignore
    this.uploadFileNum--;
    this.addFile(preRequestData.dataList, preRequestData.currentDataList);
  };

  /**
   * Add Files - Default upload one file and will callback self if has other files
   * @param {*} dataList Page File List
   * @param {*} currentDataList The remaining data needs to be uploaded
   * @returns
   */
  addFile = (dataList: any, currentDataList: any) => {
    // @ts-ignore
    currentDataList = currentDataList ?? this.fileList;
    const item = currentDataList.splice(0, 1)[0];

    if (this.checkFileDuplicate(dataList, currentDataList, item)) {
      return;
    }
    this.addFileFunc(dataList, currentDataList, item);
  };

  /**
   * Check File Name Duplicate
   * @param {*} dataList Page File List
   * @param {*} currentDataList The remaining data needs to be uploaded
   * @param {*} currentItem Current File
   * @returns {boolean}
   */
  checkFileDuplicate = (dataList: any, currentDataList: any, currentItem: any) => {
    const dataIndex = dataList.findIndex((dataItem: any) => dataItem.name === currentItem.name);
    if (dataIndex !== -1 && this.props.isMultiple) {
      this.setState({
        isModalOpen: true,
        modalChildContent: `${currentItem.name} already exists. Do you want to replace it?`,
        handleModalConfirm: () => {
          if (dataIndex !== -1) {
            dataList.splice(dataIndex, 1);
          }
          this.hideModal();
          this.addFileFunc(dataList, currentDataList, currentItem);
        },
        handleModalCancel: () => {
          this.hideModal();
          if (currentDataList.length === 0) {
            this.props.updateFileNumLoading != null
              ? this.props.updateFileNumLoading({
                  currentNum: 0,
                  allNum: 0,
                })
              : this.props.hideLoading();
            // @ts-ignore
            this.uploadFileNum = 0;
            return;
          }

          this.addFile(dataList, currentDataList);
        },
      });
      /// Has Duplicate File Name
      return true;
    }

    return false;
  };

  /**
   * General dto to send upload file request
   * @param {*} dataList Page File List
   * @param {*} currentDataList The remaining data needs to be uploaded
   * @param {*} currentItem Current File
   */
  addFileFunc = (dataList: any, currentDataList: any, currentItem: any) => {
    let fileForm = new FormData();
    let addFileDto = this.getAddFileDto(currentItem);
    fileForm.append("formFile", currentItem);
    fileForm.append("addFileDto", JSON.stringify(addFileDto));
    ProcedureDetailService.addFile(
      fileForm,
      this.onAddFileSuccess,
      (response: any) => {
        this._alertError("Upload File Failed");
        console.log(response);
      },
      {
        dataList: dataList,
        currentDataList: currentDataList,
        dataItem: currentItem,
      }
    );
  };

  /* function about upload file */
  FileProcess = (index: any, dataList: any) => {
    // @ts-ignore
    if (this.fileList === undefined || this.fileList === null || this.fileList.length === 0) {
      return;
    }

    // @ts-ignore
    this.uploadFileNum += this.fileList.length;
    this.props.updateFileNumLoading != null
      ? this.props.updateFileNumLoading({
          currentNum: 0,
          // @ts-ignore
          allNum: this.fileList.length,
        })
      : this.props.openLoading();
    // @ts-ignore
    this.addFile(dataList);
  };

  /* function about upload mutiple file */
  handleInsertFile = (files: any) => {
    // @ts-ignore
    this.fileList = [...files];
    // @ts-ignore
    this.fileNum = files.length;
    // @ts-ignore
    if (handleAlertUploadFileError(this.fileList)) {
      return;
    }

    /// File List Before Insert
    let dataList = [...this.state.fileList];

    this.FileProcess(0, dataList);
  };

  /* function about upload single file */
  handleInsertSingleFile = (files: any) => {
    // @ts-ignore
    this.fileList = [...files];
    // @ts-ignore
    this.fileNum = files.length;
    // @ts-ignore
    for (let fileItem of this.fileList) {
      if (fileItem.size > MAX_FILE_SIZE_BYTES) {
        this._alertError("The limit of a single attachment is no larger than 300MB.");
        return;
      }
    }

    /// File List Before Insert
    let dataList = [...this.state.fileList];

    this.FileProcess(0, dataList);
  };

  clearFileList = () => {
    this.setState({
      fileList: [],
    });
  };

  /* function about click delete button to delete file */
  deleteFile = (item: any, index: any) => {
    this.state.fileList.splice(index, 1);
    this.setState({
      fileList: this.state.fileList,
      fileIdList: this.state.fileIdList,
    });
    const fileId = this.state.fileIdList[index];
    let dto = {
      ProductKey: AppSetting.urlPrefix.deleteFile.ProductKey,
      StorageFileID: fileId,
    };
    this.props.isMultiple &&
      ProcedureDetailService.deleteFile(
        dto,
        () => {
          this._alertSuccess("Delete Successful");
          this.state.fileIdList.splice(index, 1);
          this.props.isMultiple && this.props.handleFileListChange(this.state.fileList);
          // @ts-ignore
          this.isDeleting = false;
        },
        (response: any) => {
          console.log(response);
          // @ts-ignore
          this.isDeleting = false;
        },
        fileId
      );
  };

  /* function about check whether error if this part is manatory */
  checkMandatory = () => {
    this.setState({
      isError: true,
    });
  };

  /* function about cancel error if this part is manatory */
  cancelMandatory = () => {
    this.setState({
      isError: false,
    });
  };

  /* function about drag and drop files to upload */
  dragEnter = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
  };

  dragOver = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
  };

  drop = (e: any) => {
    const isEditable = this.props.isShowDeleteBtn;
    if (isEditable !== undefined && isEditable === true) {
      if (this.props.isMultiple) {
        this.handleInsertFile(e.dataTransfer.files);
      } else {
        this.handleInsertSingleFile(e.dataTransfer.files);
      }
    }
    e.preventDefault();
    e.stopPropagation();
  };

  /* function about clear files */
  clearFileAttach = () => {
    this.setState({
      fileList: [],
    });
  };

  /* function about download file */
  loadFiles = () => {
    const { fileIds, fileNames } = this.props;
    const files: any[] = [];
    fileNames.forEach((item: any, index: any) => {
      files.unshift({
        name: item,
        size: index,
      });
    });

    this.setState({
      fileList: [...this.state.fileList, ...files],
      fileIdList: [...this.state.fileIdList, ...fileIds],
    });
  };

  componentDidUpdate(prevProps: any, prevState: any) {
    const { fileIds } = this.props;
    if (
      JSON.stringify(prevProps.fileIds) !== JSON.stringify(this.props.fileIds) ||
      prevProps.isShowDragger !== this.props.isShowDragger
    ) {
      fileIds.length !== 0 && this.loadFiles();
    }
  }

  componentDidMount() {
    this.props.fileIds.length !== 0 && this.loadFiles();
  }

  render() {
    const {
      isMultiple = false,
      rowindex,
      className = "",
      isShowDeleteBtn,
      fileNameType,
      isDownload,
      fileUploadDraggerLabel,
    } = this.props;
    const {
      fileList,
      fileIdList,
      modalChildContent,
      isModalOpen,
      isError,
      handleModalCancel,
      handleModalConfirm,
    } = this.state;
    const disableClass = !isShowDeleteBtn ? "disableUpload" : "";
    return (
      <div className={`${className} fileUploadContainer`}>
        {fileUploadDraggerLabel}
        <div
          className={`uploadInputContainer ${disableClass}`}
          onClick={this.handleFileUpload}
          onDragEnter={this.dragEnter}
          onDragOver={this.dragOver}
          onDrop={this.drop}
          style={{
            borderColor: isError ? "red" : "rgba(47, 97, 176, 0.5)",
          }}
        >
          <p className="fileUploadIcon">
            <img src={uploadFileIcon} alt="Upload File" />
          </p>
          <p className="fileUploadTip">Drag and Drop files here</p>
          {!isMultiple && (
            <div className="tipContainer">
              <div>
                <img src={tipIcon} alt="Only One Tip" />
              </div>
              <p className="onlyOneTip">
                You can only upload one file as attachment. If you upload again, the old one will be
                replaced.
              </p>
            </div>
          )}
        </div>
        {/* @ts-ignore */}
        <input
          type="file"
          id="uploadInput"
          multiple={isMultiple}
          ref={this.props.fileInputRef}
          onChange={(e) => {
            if (this.props.isMultiple) {
              this.handleInsertFile(e.target.files);
            } else {
              this.handleInsertSingleFile(e.target.files);
            }
          }}
          rowindex={rowindex}
          data-testid="upload-file-input"
        />
        {fileList.map((item: any, index: any) => (
          // @ts-ignore
          <FileItem
            fileName={item.name}
            fileType={item.name}
            fileSize={item.size}
            ref={fileItemRef}
            index={index}
            fileItemRef={fileItemRef}
            deleteFile={() => {
              // @ts-ignore
              this.isDeleting = true;
              this.deleteFile(item, index);
            }}
            fileList={fileList}
            isShowDeleteBtn={isShowDeleteBtn}
            key={crypto.randomUUID()}
            fileNameType={fileNameType}
            fileId={item.storageFileID || fileIdList[item.size]}
            isDownload={isDownload}
          />
        ))}
        <NormalModal
          okText="Replace"
          cancelText="Skip"
          childContent={<p className="fs-16">{modalChildContent}</p>}
          isModalOpen={isModalOpen}
          zIndex={1501}
          handleOk={handleModalConfirm}
          handleCancel={() => {
            handleModalCancel();
          }}
        />
      </div>
    );
  }
}

/**
 * component for attachment field for revision information
 */
export class RevisionInfoUploadFile extends FileUploadDragger {
  /* function about click delete button to delete file */
  deleteFile = (item: any, index: any) => {
    const fileId = this.props.files.find((file: any) => file.fileName === item.name)?.fileId;
    const fileList = this.state.fileList.filter((file: any) => file.name !== item.name);
    const fileIdList = this.state.fileIdList.filter((id: any) => id !== fileId);
    this.setState({
      fileList,
      fileIdList,
    });
    this.props.handleChangeDeleteIds(fileId);

    // @ts-ignore
    ProcedureDetailService.deleteFile(
      {
        ProductKey: AppSetting.urlPrefix.deleteFile.ProductKey,
        StorageFileID: fileId,
      },
      () => {
        this._alertSuccess("Delete Successful");
      },
      (response: any) => {
        console.log(response);
      }
    );
  };
}

export default UploadFile;

export { FileUploadDragger };
